import Action from '../Action';
import { useEffect, useState } from 'react';
import LoadSimple from '../LoadSimple';
import { capitalizeFirstLetter } from '../../utils/utils';
import { useFetch } from '../../hooks/useFetch';
import { lang } from '../generales/traduction';
import Search from '../generales/Search';
import Paginador from '../generales/Paginador';
import SelectorAdmin from '../SelectorAdmin';

const ModalAddProblem = ({ editActive, event, languaje, search_problems, appSelected, server, mode, setPoolRows, poolObjectRows, setPoolObjectRows, poolRows, handleShowPopup, closeAddHostModal }) => {
  const [hosts, setHosts] = useState({
    data: [],
    loading: true,
    error: null,
  })
  const [dataEvent, setDataEvent] = useState({
    data: [],
    loading: false,
    error: null,
  })
  const [responseAction, setResponseAction] = useState({
    data: [],
    loading: false,
    error: null,
  })
  const [loading, setLoading] = useState(false)
  const type_list = useFetch('cassia/events_correlations/types', '', '', 'GET', server)
  const [ManttoData, setManttoData] = useState({
    name: "",
    type: "",
    eventids: []
  })
  const [ManttoDataAux, setManttoDataAux] = useState({
    name: "",
    type: "",
    eventids: []
  })
  const [disable, setDisable] = useState(true)

  // ─── NUEVO: estado del tab activo (solo UI, no afecta lógica) ───────────
  const [activeTab, setActiveTab] = useState('disponibles') // 'disponibles' | 'seleccionados'

  useEffect(() => {
    if (editActive) {
      search_event()
    }
    buscar_cis();
  }, []);

  useEffect(() => {
    if (ManttoData.name == "" || ManttoData.type == "" || poolRows.length == 0) {
      setDisable(true)
    } else {
      setDisable(false)
    }
  }, [ManttoData, poolRows])

  const search_event = () => {
    setDataEvent({
      data: hosts.data,
      loading: true,
      error: hosts.error,
    });

    const fetchDataPost = async () => {
      try {
        const response = await fetch(
          server.url +
          "/api/v1/cassia/events_correlations/" + event.eventid,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        if (response.ok) {
          const data1 = await response.json();

          setDataEvent({
            data: data1.data,
            loading: false,
            error: hosts.error,
          });
          const [antes, despues] = data1.data.message.split(":").map(part => part.trim());
          const antesLimpio = antes.replace(/\([-+]?\d+\)/, "").trim();
          setManttoData({
            name: despues,
            type: antesLimpio,
            eventids: data1.data.events_correlated
          })
          setManttoDataAux({
            name: despues,
            type: antesLimpio,
            eventids: data1.data.events_correlated
          })
          setPoolObjectRows(data1.data.events_correlated)
          setPoolRows(data1.data.events_correlated.map(item => item.cassia_arch_traffic_events_id))
        } else {
          const data1 = await response.json();
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };

  const buscar_cis = () => {
    setHosts({
      data: hosts.data,
      loading: true,
      error: hosts.error,
    });

    const fetchDataPost = async () => {
      try {
        const response = await fetch(
          server.url +
          "/api/v1/cassia/events_correlations/get_events_without_correlation",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        if (response.ok) {
          const data1 = await response.json();
          setHosts({
            data: data1.data,
            loading: false,
            error: hosts.error,
          });
        } else {
          const data1 = await response.json();
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };

  const registrar = () => {
    setResponseAction({
      data: responseAction.data,
      loading: true,
      error: responseAction.error,
    });

    const data = {
      name: ManttoData.name,
      type: ManttoData.type,
      eventids: poolRows
    }
    const url = (editActive) ? event.eventid : ''
    const fetchDataPost = async () => {
      try {
        const response = await fetch(
          server.url +
          "/api/v1/cassia/events_correlations/" + url,
          {
            method: (editActive) ? "PUT" : "POST",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
            body: JSON.stringify(data)
          }
        );
        if (response.ok) {
          const data1 = await response.json();
          setResponseAction({
            data: data1,
            loading: false,
            error: responseAction.error,
          });
          setPoolObjectRows([])
          setPoolRows([])
          handleShowPopup('Completado!!!', '', data1.message, true)
          closeAddHostModal()
          search_problems()
        } else {
          const data1 = await response.json();
          setResponseAction({
            data: responseAction.data,
            loading: false,
            error: responseAction.error,
          });
          handleShowPopup('Error!!!', capitalizeFirstLetter(lang[languaje]['errorActionComplet']), data1.detail, false)
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };

  const [allSelected, setAllSelected] = useState(false);
  const [hostSelected, setHostSelected] = useState([])
  const [contRowsSelected, setContRowSelected] = useState(0)
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [limitList, setLimitList] = useState(50);
  const [pageActual, setPageActual] = useState(1);
  const [searchResult, setSearchResult] = useState(null);
  var dataList = searchTerm === "" ? hosts.data : searchResults;
  const startLimit = limitList * pageActual - limitList;
  const pages = parseInt(dataList.length / limitList) + 1;

  const [searchResults2, setSearchResults2] = useState([]);
  const [searchTerm2, setSearchTerm2] = useState("");
  const [limitList2, setLimitList2] = useState(50);
  const [pageActual2, setPageActual2] = useState(1);
  const [searchResult2, setSearchResult2] = useState(null);
  var dataList2 = searchTerm2 === "" ? poolObjectRows : searchResults2;
  const startLimit2 = limitList2 * pageActual2 - limitList2;
  const pages2 = parseInt(dataList2.length / limitList2) + 1;

  const handleSelectAll = () => {
    if (allSelected) {
      setPoolRows([]);
      setPoolObjectRows([])
    } else {
      setPoolRows(hosts.data.map(item => item.cassia_arch_traffic_events_id))
      setPoolObjectRows(hosts.data)
    }
    setAllSelected(!allSelected);
  };

  const handleSearch = (query) => {
    setSearchResult(`Resultados para: ${query}`);
  };

  const handleSelectChange = (e) => {
    setPageActual(1)
    setLimitList(e.target.value); setPageActual(1);
  };

  const handleSelectChange2 = (e) => {
    setPageActual2(1)
    setLimitList2(e.target.value); setPageActual2(1);
  };

  const rowSelected = (elemento) => {
    if (allSelected) {
      setAllSelected(false)
    }

    setPoolRows((prevRows) => {
      const exists = (elemento.eventid == undefined) ? prevRows.includes(elemento.cassia_arch_traffic_events_id) : prevRows.includes(elemento.eventid);
      if (exists) {
        return (elemento.eventid == undefined) ? prevRows.filter(cassia_arch_traffic_events_id => cassia_arch_traffic_events_id !== elemento.cassia_arch_traffic_events_id) : prevRows.filter(eventid => eventid !== elemento.eventid);
      } else {
        return [...prevRows, (elemento.eventid == undefined) ? elemento.cassia_arch_traffic_events_id : elemento.eventid];
      }
    });
    setPoolObjectRows((prevRows) => {
      const getId = (obj) => obj?.cassia_arch_traffic_events_id ?? obj?.eventid;
      const newId = getId(elemento);
      const exists = prevRows.some(evento => getId(evento) === newId);

      if (exists) {
        return prevRows.filter(evento => getId(evento) !== newId);
      } else {
        return [...prevRows, elemento];
      }
    });
    setHostSelected((prevRows) => {
      const exists = prevRows.some(item => item.hostid === elemento.hostid);
      if (exists) {
        return prevRows.filter(item => item.hostid !== elemento.hostid);
      } else {
        return [...prevRows, elemento];
      }
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target
    setManttoData((prevState) => {
      return {
        ...prevState,
        [name]: value
      }
    })
  }

  const changeOption = (option, index) => {
    setManttoData((prevState) => {
      return {
        ...prevState,
        ['type']: option.label
      }
    })
  }

  const { name, type } = ManttoData;

  // ═══════════════════════════════════════════════════════════════════════
  // PALETA DE COLORES — SISTEMA "CLEAN BLUE"
  // ═══════════════════════════════════════════════════════════════════════
  const C = {
    bl: '#1a56db',
    blDark: '#0f2d5e',
    bl5: '#e8f0fe',
    bl2: '#1c64f2',
    txt: '#0f172a',
    txt2: '#334155',
    txt3: '#64748b',
    txt4: '#94a3b8',
    b1: '#e2e8f0',
    b2: '#cbd5e1',
    bg: '#f8fafc',
    bg2: '#f1f5f9',
    wh: '#ffffff',
    gr: '#057a55',
    grSoft: '#e8f5ee',
    red: '#e02424',
    redSoft: '#fef2f2',
    amb: '#d97706',
    ambSoft: '#fef3c7',
    pur: '#7e3af2',
    purSoft: '#f3e8ff',
  };

  return (
    <>
      <div className="modal-GS-content">
        <div
          className='card-modal-gs modal-verificate'
          style={{
            background: C.wh,
            borderRadius: 12,
            overflow: 'hidden',
            boxShadow: '0 20px 60px rgba(15,45,94,0.25)',
            border: `1px solid ${C.b1}`,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {/* ═══════════════════════════════════════════════════════════════
              HEADER AZUL MARINO
              ═══════════════════════════════════════════════════════════════ */}
          <div
            style={{
              background: C.blDark,
              padding: '16px 20px',
              display: 'flex',
              alignItems: 'center',
              gap: 14,
              flexShrink: 0,
            }}
          >
            {/* Icono */}
            <div
              style={{
                width: 40,
                height: 40,
                borderRadius: 8,
                background: 'rgba(255,255,255,0.1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
            </div>

            {/* Título y subtítulo */}
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ color: C.wh, fontSize: 16, fontWeight: 600, lineHeight: 1.2 }}>
                {(editActive ? capitalizeFirstLetter(lang[languaje]['editar']) : capitalizeFirstLetter(lang[languaje]['crear'])) + ' ' + capitalizeFirstLetter(lang[languaje]['eventoCorrelacionado'])}
              </div>
              <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12, marginTop: 2 }}>
                {capitalizeFirstLetter(lang[languaje]['agruparEventos'] || 'Agrupa varios eventos bajo una correlación')}
              </div>
            </div>

            {/* Botón cerrar */}
            <button
              onClick={closeAddHostModal}
              style={{
                width: 36,
                height: 36,
                borderRadius: 8,
                background: 'rgba(255,255,255,0.1)',
                border: 'none',
                color: C.wh,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}
              title={capitalizeFirstLetter(lang[languaje]['cerrar'] || 'Cerrar')}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </div>

          {/* ═══════════════════════════════════════════════════════════════
              BARRA META — Nombre / Tipo / Conteo
              ═══════════════════════════════════════════════════════════════ */}
          <div
            style={{
              background: C.bg,
              padding: '7px 20px',
              borderBottom: `1px solid ${C.b1}`,
              display: 'grid',
              gridTemplateColumns: '1fr 1fr auto',
              gap: 20,
              alignItems: 'center',
              flexShrink: 0,
            }}
          >
            {/* Nombre */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6, minWidth: 0 }}>
              <label style={{ fontSize: 11, fontWeight: 600, color: C.txt3, textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                {capitalizeFirstLetter(lang[languaje]['nombre'])}
              </label>
              <input
                required
                name="name"
                type="text"
                value={name}
                onChange={handleChange}
                placeholder={capitalizeFirstLetter(lang[languaje]['nombre'])}
                style={{
                  height: 36,
                  padding: '0 12px',
                  border: `1px solid ${C.b1}`,
                  borderRadius: 8,
                  background: C.wh,
                  fontSize: 13,
                  color: C.txt,
                  outline: 'none',
                  width: '100%',
                  boxSizing: 'border-box',
                }}
                onFocus={(e) => { e.target.style.borderColor = C.bl; e.target.style.boxShadow = `0 0 0 3px ${C.bl5}`; }}
                onBlur={(e) => { e.target.style.borderColor = C.b1; e.target.style.boxShadow = 'none'; }}
              />
            </div>

            {/* Tipo */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6, minWidth: 0 }}>
              <label style={{ fontSize: 11, fontWeight: 600, color: C.txt3, textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                {capitalizeFirstLetter(lang[languaje]['tipo'])}
              </label>
              <div style={{ width: '100%', minWidth: 0 }}>
                {(type_list.loading) ? (
                  <div style={{ height: 36, display: 'flex', alignItems: 'center', color: C.txt3, fontSize: 13 }}>. . .</div>
                ) : (
                  <SelectorAdmin
                    placeholder={'Seleccionar tipo...'}
                    opGeneral={true}
                    txtOpGen={''}
                    opt_de={(editActive) ? type_list.data.data.find(e => e.name == ManttoDataAux.type).id : 0}
                    origen={'Admin'}
                    data={type_list.data.data}
                    loading={type_list.loading}
                    titulo='Event'
                    selectFunction={changeOption}
                    index={0}
                  />
                )}
              </div>
            </div>

            {/* Conteo */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                background: C.bl5,
                color: C.bl,
                padding: '8px 14px',
                borderRadius: 999,
                fontSize: 12,
                fontWeight: 600,
                whiteSpace: 'nowrap',
                alignSelf: 'flex-end',
                marginBottom: 1,
              }}
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12" />
              </svg>
              {poolRows.length} {capitalizeFirstLetter(lang[languaje]['seleccionados'] || 'seleccionados')}
            </div>
          </div>

          {/* ═══════════════════════════════════════════════════════════════
              TABS — Disponibles / Seleccionados
              ═══════════════════════════════════════════════════════════════ */}
          <div
            style={{
              display: 'flex',
              gap: 0,
              padding: '0 20px',
              background: C.wh,
              borderBottom: `1px solid ${C.b1}`,
              flexShrink: 0,
              height: '5%'
            }}
          >
            {[
              { key: 'disponibles', label: capitalizeFirstLetter(lang[languaje]['disponibles'] || 'Disponibles'), count: hosts.data.length },
              { key: 'seleccionados', label: capitalizeFirstLetter(lang[languaje]['seleccionados'] || 'Seleccionados'), count: poolObjectRows.length },
            ].map(tab => {
              const active = activeTab === tab.key;
              return (
                <button
                  key={tab.key}
                  onClick={() => setActiveTab(tab.key)}
                  style={{
                    background: 'transparent',
                    border: 'none',
                    padding: '14px 20px',
                    cursor: 'pointer',
                    fontSize: 13,
                    fontWeight: active ? 600 : 500,
                    color: active ? C.bl : C.txt3,
                    borderBottom: active ? `2px solid ${C.bl}` : '2px solid transparent',
                    marginBottom: -1,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    transition: 'all 0.15s',
                  }}
                >
                  {tab.label}
                  <span
                    style={{
                      background: active ? C.bl5 : C.bg2,
                      color: active ? C.bl : C.txt3,
                      padding: '2px 8px',
                      borderRadius: 999,
                      fontSize: 11,
                      fontWeight: 600,
                      minWidth: 22,
                      textAlign: 'center',
                    }}
                  >
                    {tab.count}
                  </span>
                </button>
              );
            })}
          </div>

          {/* ═══════════════════════════════════════════════════════════════
              CUERPO — Tabla activa según el tab
              ═══════════════════════════════════════════════════════════════ */}
          <div
            style={{
              flex: 1,
              minHeight: 0,
              display: 'flex',
              flexDirection: 'column',
              background: C.wh,
              overflow: 'hidden',
            }}
          >
            {(dataEvent.loading || type_list.loading) ? (
              <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <LoadSimple />
              </div>
            ) : (
              <>
                {/* ─── TAB: DISPONIBLES ─────────────────────────────────── */}
                {activeTab === 'disponibles' && (
                  <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                    {/* Toolbar buscador */}
                    <div
                      style={{
                        padding: '14px 20px',
                        borderBottom: `1px solid ${C.b1}`,
                        display: 'flex',
                        gap: 12,
                        alignItems: 'center',
                        background: C.wh,
                      }}
                    >
                      <div style={{ flex: 1 }}>
                        <Search
                          searchResults={searchResults}
                          setSearchResults={setSearchResults}
                          searchTerm={searchTerm}
                          setSearchTerm={setSearchTerm}
                          onSearch={handleSearch}
                          dataObject={hosts.data}
                          searchResult={searchResult}
                          setSearchResult={setSearchResult}
                          languaje={languaje}
                        />
                      </div>
                      <div style={{ marginLeft: 'auto', fontSize: 12, color: C.txt3 }}>
                        {dataList.length} {lang[languaje]['resultados'] || 'resultados'}
                      </div>
                    </div>

                    {/* Tabla disponibles */}
                    <div style={{ flex: 1, overflow: 'auto', minHeight: 0 }}>
                      {(hosts.loading) ? (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
                          <LoadSimple />
                        </div>
                      ) : (
                        <table
                          style={{
                            width: '100%',
                            borderCollapse: 'separate',
                            borderSpacing: 0,
                            fontSize: 13,
                          }}
                        >
                          <thead>
                            <tr>
                              <th style={thStyle(C, 48)}>
                                <input
                                  type='checkbox'
                                  className='NotifiCheckBox'
                                  checked={allSelected}
                                  onChange={() => handleSelectAll()}
                                  style={{ height: 15, cursor: 'pointer' }}
                                />
                              </th>
                              <th style={thStyle(C)}>Event ID</th>
                              <th style={thStyle(C)}>{capitalizeFirstLetter(lang[languaje]['evento'])}</th>
                              <th style={thStyle(C)}>{capitalizeFirstLetter(lang[languaje]['afiliacion'])}</th>
                              <th style={thStyle(C)}>IP</th>
                            </tr>
                          </thead>
                          <tbody>
                            {dataList
                              .slice(startLimit, parseInt(pageActual) * parseInt(limitList))
                              .map((elemento, indice) => {
                                const checked = poolRows.some((row) => row === elemento.cassia_arch_traffic_events_id);
                                const disabled = elemento.softwarestatus != null;
                                return (
                                  <tr
                                    key={indice}
                                    title={`Status: ${elemento.status ?? elemento.Estatus}`}
                                    style={{
                                      background: indice % 2 === 0 ? C.wh : C.bg,
                                      opacity: disabled ? 0.5 : 1,
                                    }}
                                  >
                                    <td style={tdStyle(C)}>
                                      <input
                                        type='checkbox'
                                        checked={checked}
                                        className='NotifiCheckBox'
                                        style={{ height: 15, cursor: disabled ? 'not-allowed' : 'pointer' }}
                                        onChange={() => rowSelected(elemento)}
                                        disabled={disabled}
                                      />
                                    </td>
                                    <td style={{ ...tdStyle(C), fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace' }}>
                                      <span style={chipMonoStyle(C)}>
                                        {elemento.cassia_arch_traffic_events_id}
                                      </span>
                                    </td>
                                    <td style={{ ...tdStyle(C), color: (elemento.status === 'RESOLVED') ? C.gr : C.red, fontWeight: 500 }}>
                                      {elemento.message}
                                    </td>
                                    <td style={tdStyle(C)}>
                                      {elemento.afiliacion}
                                    </td>
                                    <td style={{ ...tdStyle(C), fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace', color: C.txt2 }}>
                                      {elemento.ip}
                                    </td>
                                  </tr>
                                );
                              })}
                            {dataList.length === 0 && (
                              <tr>
                                <td colSpan={5} style={{ ...tdStyle(C), textAlign: 'center', color: C.txt3, padding: '32px 16px' }}>
                                  {capitalizeFirstLetter(lang[languaje]['sinResultados'])}.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      )}
                    </div>

                    {/* Paginador disponibles */}
                    <div
                      style={{
                        padding: '12px 20px',
                        borderTop: `1px solid ${C.b1}`,
                        background: C.bg,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 16,
                        flexShrink: 0,
                        height: '5%'
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <label style={{ fontSize: 12, color: C.txt3 }}>
                          {capitalizeFirstLetter(lang[languaje]['filasPagina'])}:
                        </label>
                        <select
                          value={limitList}
                          className="pageSelector"
                          onChange={handleSelectChange}
                          style={selectStyle(C)}
                        >
                          <option value={10}>10</option>
                          <option value={50}>50</option>
                          <option value={100}>100</option>
                          <option value={500}>500</option>
                          <option value={1000}>1000</option>
                        </select>
                      </div>

                      <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
                        <Paginador
                          pages={pages}
                          pageActual={pageActual}
                          setPageActual={setPageActual}
                          mode={mode}
                        />
                      </div>

                      <div style={{ fontSize: 12, color: C.txt3, whiteSpace: 'nowrap' }}>
                        {"(" + (startLimit + 1) + " - " +
                          (dataList.length > parseInt(pageActual) * parseInt(limitList)
                            ? parseInt(pageActual) * parseInt(limitList)
                            : dataList.length) +
                          ") " + lang[languaje]['de'] + " " + dataList.length + " " + lang[languaje]['resultados']}
                      </div>
                    </div>
                  </div>
                )}

                {/* ─── TAB: SELECCIONADOS ────────────────────────────────── */}
                {activeTab === 'seleccionados' && (
                  <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                    {/* Toolbar buscador seleccionados */}
                    <div
                      style={{
                        padding: '14px 20px',
                        borderBottom: `1px solid ${C.b1}`,
                        display: 'flex',
                        gap: 12,
                        alignItems: 'center',
                        background: C.wh,
                      }}
                    >
                      <div style={{ flex: 1 }}>
                        <Search
                          searchResults={searchResults2}
                          setSearchResults={setSearchResults2}
                          searchTerm={searchTerm2}
                          setSearchTerm={setSearchTerm2}
                          onSearch={handleSearch}
                          dataObject={poolObjectRows}
                          searchResult={searchResult2}
                          setSearchResult={setSearchResult2}
                          languaje={languaje}
                        />
                      </div>
                      <div style={{ marginLeft: 'auto', fontSize: 12, color: C.txt3 }}>
                        {dataList2.length} {lang[languaje]['resultados'] || 'resultados'}
                      </div>
                    </div>

                    {/* Tabla seleccionados */}
                    <div style={{ flex: 1, overflow: 'auto', minHeight: 0 }}>
                      {(hosts.loading) ? (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
                          <LoadSimple />
                        </div>
                      ) : (
                        <table
                          style={{
                            width: '100%',
                            borderCollapse: 'separate',
                            borderSpacing: 0,
                            fontSize: 13,
                          }}
                        >
                          <thead>
                            <tr>
                              <th style={thStyle(C)}>Event ID</th>
                              <th style={thStyle(C)}>{capitalizeFirstLetter(lang[languaje]['evento'])}</th>
                              <th style={thStyle(C)}>{capitalizeFirstLetter(lang[languaje]['afiliacion'])}</th>
                              <th style={thStyle(C)}>{capitalizeFirstLetter(lang[languaje]['dispositivo'])}</th>
                              <th style={thStyle(C)}>IP</th>
                              <th style={thStyle(C)}>Status</th>
                              <th style={thStyle(C, 60)}></th>
                            </tr>
                          </thead>
                          <tbody>
                            {dataList2
                              .slice(startLimit2, parseInt(pageActual2) * parseInt(limitList2))
                              .map((elemento, indice) => {
                                const status = elemento.status ?? elemento.Estatus;
                                const isResolved = status === 'RESOLVED';
                                return (
                                  <tr
                                    key={indice}
                                    title={`Status: ${status}`}
                                    style={{ background: indice % 2 === 0 ? C.wh : C.bg }}
                                  >
                                    <td style={{ ...tdStyle(C), fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace' }}>
                                      <span style={chipMonoStyle(C)}>
                                        {(elemento.eventid == undefined) ? elemento.cassia_arch_traffic_events_id : elemento.eventid}
                                      </span>
                                    </td>
                                    <td style={tdStyle(C)}>
                                      {(elemento.eventid == undefined) ? elemento.message : elemento.Problem}
                                    </td>
                                    <td style={tdStyle(C)}>
                                      {(elemento.eventid == undefined) ? elemento.afiliacion : elemento.affiliation}
                                    </td>
                                    <td style={{ ...tdStyle(C), fontWeight: 500, color: C.txt }}>
                                      {(elemento.Host ?? elemento.hostname)}
                                    </td>
                                    <td style={{ ...tdStyle(C), fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace', color: C.txt2 }}>
                                      {elemento.ip}
                                    </td>
                                    <td style={tdStyle(C)}>
                                      <span style={statusBadgeStyle(C, isResolved)}>
                                        {status}
                                      </span>
                                    </td>
                                    <td style={tdStyle(C)}>
                                      <button
                                        onClick={() => rowSelected(elemento)}
                                        style={{
                                          width: 28,
                                          height: 28,
                                          borderRadius: 6,
                                          background: C.redSoft,
                                          color: C.red,
                                          border: 'none',
                                          cursor: 'pointer',
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                        }}
                                        title={capitalizeFirstLetter(lang[languaje]['eliminar'] || 'Eliminar')}
                                      >
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                          <polyline points="3 6 5 6 21 6" />
                                          <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                                          <path d="M10 11v6" />
                                          <path d="M14 11v6" />
                                          <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
                                        </svg>
                                      </button>
                                    </td>
                                  </tr>
                                );
                              })}
                            {dataList2.length === 0 && (
                              <tr>
                                <td colSpan={7} style={{ ...tdStyle(C), textAlign: 'center', color: C.txt3, padding: '40px 16px' }}>
                                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}>
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke={C.txt4} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                      <rect x="3" y="3" width="18" height="18" rx="2" />
                                      <path d="M9 12h6" />
                                    </svg>
                                    <div>{capitalizeFirstLetter(lang[languaje]['sinResultados'])}.</div>
                                    <div style={{ fontSize: 11, color: C.txt4 }}>
                                      {capitalizeFirstLetter(lang[languaje]['agregaEventos'] || 'Selecciona eventos desde la pestaña "Disponibles"')}
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      )}
                    </div>

                    {/* Paginador seleccionados */}
                    <div
                      style={{
                        padding: '12px 20px',
                        borderTop: `1px solid ${C.b1}`,
                        background: C.bg,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 16,
                        flexShrink: 0,
                        height: '5%'
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <label style={{ fontSize: 12, color: C.txt3 }}>
                          {capitalizeFirstLetter(lang[languaje]['filasPagina'])}:
                        </label>
                        <select
                          value={limitList2}
                          className="pageSelector"
                          onChange={handleSelectChange2}
                          style={selectStyle(C)}
                        >
                          <option value={10}>10</option>
                          <option value={50}>50</option>
                          <option value={100}>100</option>
                          <option value={500}>500</option>
                          <option value={1000}>1000</option>
                        </select>
                      </div>

                      <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
                        <Paginador
                          pages={pages2}
                          pageActual={pageActual2}
                          setPageActual={setPageActual2}
                          mode={mode}
                        />
                      </div>

                      <div style={{ fontSize: 12, color: C.txt3, whiteSpace: 'nowrap' }}>
                        {"(" + (startLimit2 + 1) + " - " +
                          (dataList2.length > parseInt(pageActual2) * parseInt(limitList2)
                            ? parseInt(pageActual2) * parseInt(limitList2)
                            : dataList2.length) +
                          ") " + lang[languaje]['de'] + " " + dataList2.length + " " + lang[languaje]['resultados']}
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>

          {/* ═══════════════════════════════════════════════════════════════
              FOOTER
              ═══════════════════════════════════════════════════════════════ */}
          <div
            style={{
              padding: '14px 20px',
              borderTop: `1px solid ${C.b1}`,
              background: C.bg,
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              flexShrink: 0,
            }}
          >
            <div style={{ flex: 1, fontSize: 12, color: C.txt3, display: 'flex', alignItems: 'center', gap: 6 }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="16" x2="12" y2="12" />
                <line x1="12" y1="8" x2="12.01" y2="8" />
              </svg>
              {poolRows.length} {capitalizeFirstLetter(lang[languaje]['eventosSeleccionados'] || 'eventos seleccionados')}
              {(name && type) ? ` · ${type} · ${name}` : ''}
            </div>

            <div style={{ display: 'flex', gap: 8 }}>
              {(responseAction.loading) ? (
                <LoadSimple />
              ) : (
                <>
                  <Action
                    disabled={false}
                    origen="Cancelar"
                    titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])}
                    action={closeAddHostModal}
                  />
                  <Action
                    disabled={disable}
                    origen="Azul"
                    titulo={editActive ? capitalizeFirstLetter(lang[languaje]['editar']) : capitalizeFirstLetter(lang[languaje]['crear'])}
                    action={registrar}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

// ═══════════════════════════════════════════════════════════════════════════
// HELPERS DE ESTILO — para mantener el JSX limpio
// ═══════════════════════════════════════════════════════════════════════════
const thStyle = (C, width) => ({
  background: C.blDark,
  color: C.wh,
  fontSize: 11,
  fontWeight: 600,
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
  padding: '12px 14px',
  textAlign: 'left',
  position: 'sticky',
  top: 0,
  zIndex: 1,
  whiteSpace: 'nowrap',
  ...(width ? { width } : {}),
});

const tdStyle = (C) => ({
  padding: '12px 14px',
  borderBottom: `1px solid ${C.b1}`,
  color: C.txt2,
  verticalAlign: 'middle',
});

const chipMonoStyle = (C) => ({
  display: 'inline-block',
  padding: '3px 10px',
  background: C.bl5,
  color: C.bl,
  borderRadius: 6,
  fontSize: 12,
  fontWeight: 600,
  fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
});

const statusBadgeStyle = (C, isResolved) => ({
  display: 'inline-block',
  padding: '3px 10px',
  borderRadius: 999,
  fontSize: 11,
  fontWeight: 600,
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
  background: isResolved ? C.grSoft : C.redSoft,
  color: isResolved ? C.gr : C.red,
});

const selectStyle = (C) => ({
  height: 30,
  padding: '0 8px',
  border: `1px solid ${C.b1}`,
  borderRadius: 6,
  background: C.wh,
  fontSize: 12,
  color: C.txt2,
  cursor: 'pointer',
  outline: 'none',
});

export default ModalAddProblem;